import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    personalSettings: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessible label for opening the user's Personal Settings from the account menu */
            personalSettings: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UserAvatar.personalSettings?c=1kl686ovkvn0i", defaultMessage: "Personal Settings" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
